import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LicenseMgtActions, LicenseMgtActionTypes } from '../actions/license-mgt.actions';
import {LicenseMgt} from '../license-mgt.model';
import {Node} from '../../node/node.model';

export interface State extends EntityState<LicenseMgt> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<LicenseMgt> = createEntityAdapter<LicenseMgt>({
  selectId: licenseMgt => licenseMgt.Id
});

export function sortByCreatTime(e1: LicenseMgt, e2: LicenseMgt) {
  return e1.CreateTime - e2.CreateTime;
}

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: LicenseMgtActions): State {
  switch (action.type) {
    case LicenseMgtActionTypes.GetLicenseMgts:
      adapter.removeAll(state);
      return {...state, Loaded: false, Loading: true};

    case LicenseMgtActionTypes.LoadLicenseMgts:
      return adapter.setAll(action.payload, {
        ...state,
        Loaded: true,
        Loading: false
      });

    case LicenseMgtActionTypes.DeleteLicenseMgts: {
      return adapter.removeOne(action.payload.id, state);
    }

    default:
      return state;
  }
}
